<template>
<div>
    <div>Outstandings > {{sentCount}} sent, {{readyCount}}  ready, {{waitingCount}}  waiting</div>
    <div v-if="totalCount" style="display:flex;width:100%;border-radius:20px" >
        <div class="colour-bar green" :style="{'flex-grow': sentCount}" style="border-radius: 10px 0 0 10px">
            
        </div>
        <div class="colour-bar grey lighten-1" :style="{'flex-grow': readyCount}">
            
        </div>
        <div class="colour-bar red" :style="{'flex-grow': waitingCount}" style="border-radius: 0 10px 10px 0">
            
        </div>
    </div>
</div>
</template>

<script>

import ElementHelpers from '../helpers/ElementHelpers'


export default {
    data() {
        return {
        
        }
    },
    
    props: {
        step: Object,
        size: String,
    },

    computed: {
        outstandings() {        
            return ElementHelpers.getElements().filter(o => o.type == 'Outstanding')
        },
        waitingCount() {
            return this.outstandings.filter(o => o.status == 'Waiting for Broker' || o.status == 'Waiting for Processor' || o.status == 'Waiting for Client').length
        }, 
        sentCount() {
            return this.outstandings.filter(o => o.status == 'Sent').length
        },
        readyCount() {
            return this.outstandings.filter(o => o.status == 'Ready to Send').length
        },
        totalCount() {
            return this.outstandings.length
        }

    },

    methods: {

    }
}
</script>

<style scoped>
    .colour-bar {
        padding: 3px; color:white;height:5px;
    }
</style>




// WEBPACK FOOTER //
// OutstandingsDiagram.vue?79530414